




import { Component, Vue } from 'vue-property-decorator';
import { OffersSection } from '@/components';
import { getCurrentDomain } from '@/utils';

@Component<OffreSelection>({
  components: {
    OffersSection
  },
  metaInfo() {
    return {
      title: 'Votre offre',
      titleTemplate: '%s - Jaji, La mutuelle à partager',
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          name: 'description',
          content: `Choisissez votre offre pour s'inscrire chez Jaji, La mutuelle à partager.`
        },
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: `Choix de l'offre. Jaji, La mutuelle à partager` },
        { property: 'og:site_name', content: 'Jaji' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: `${this.siteDomain}/decouvrez-nos-offres/` },
        { property: 'og:image', content: `https://www.jaji.fr/logos/jaji_simple_color.svg` },
        {
          property: 'og:description',
          content: `Choisissez votre offre pour s'inscrire chez Jaji, La mutuelle à partager.`
        },

        // Twitter card
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: `${this.siteDomain}/decouvrez-nos-offres/` },
        { name: 'twitter:title', content: `Choix de l'offre. Jaji, La mutuelle à partager` },
        {
          name: 'twitter:description',
          content: `Choisissez votre offre pour s'inscrire chez Jaji, La mutuelle à partager.`
        },
        // Your twitter handle, if you have one.
        { name: 'twitter:image:src', content: 'https://www.jaji.fr/logos/jaji_simple_color.svg' },

        // Google / Schema.org markup:
        { itemprop: 'name', content: `Choix de l'offre. Jaji, La mutuelle à partager` },
        {
          itemprop: 'description',
          content: `Choisissez votre offre pour s'inscrire chez Jaji, La mutuelle à partager.`
        },
        { itemprop: 'image', content: 'https://www.jaji.fr/logos/jaji_simple_color.svg' }
      ],
      link: [{ rel: 'canonical', href: `${this.siteDomain}/decouvrez-nos-offres/` }]
    };
  }
})
export default class OffreSelection extends Vue {
  public siteDomain = getCurrentDomain();
}
